import { makeAutoObservable } from 'mobx';
import { groupByFunction } from './utils/rxjs/groupByFunction';

export class KillTradingStore {
  root;
  tradingKilled = false;
  killTradingSubject;

  constructor(root) {
    makeAutoObservable(this);
    this.root = root;
    this.initializeStream();
  }

  initializeStream = () => {
    this.killTradingSubject = groupByFunction(
      'messageType',
      'killTrading',
      this.root.websocketSubject
    ).subscribe((msg) => this.killTrading(msg.isKilled));
  };

  killTrading = (isKilled) => (this.tradingKilled = isKilled);
}
